import {LangEngine} from "./utilities/LangEngine";

export const Store = {
    state: {
        dropdownHyperLinks: [],
        router: null,
        navDropdownInstanceList: [],
        lang: '',
        isMenuOpened: false
    },
    commit(args) {
        const emit = (type, detail) => {
            return dispatchEvent(new CustomEvent(type, {
                bubbles: true,
                cancelable: false,
                composed: false,
                detail: detail
            }));
        }
        const _validateStateFunctionParameters = value => {
            if (typeof value === 'function') {
                return value(this.state);
            } else if (typeof value === 'object') {
                return value;
            } else {
                throw new Error('Invalid type of params');
            }
        };

        const params = _validateStateFunctionParameters(args);
        for (const [key] of Object.entries(this.state)) {
            if (typeof params[key] === 'undefined') continue;
            this.state[key] = params[key];
        }
        emit('state.change', this.state);
    },

    getters: {
        getLang: () => LangEngine.from(Store.state.lang).lang
    },

    events: {
        onDropdownHidden: (handleNavDropdownHidden) => {
            for (const dropdown of Store.state.navDropdownInstanceList) {
                dropdown.addEventListener('dropdown.menu.hidden', handleNavDropdownHidden, false)
            }
        },
        onDropdownShown: (handleNavDropdownHidden) => {
            for (const dropdown of Store.state.navDropdownInstanceList) {
                dropdown.addEventListener('dropdown.menu.shown', handleNavDropdownHidden, false)
            }
        },
        on: (event, callback) => {
            addEventListener(event, callback, false);
        }
    }
}
